<template lang="pug">
    .spinner
        b-spinner(type="grow" label="Loading...")
        .ml-3 {{ text }}
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        text: {
            type: String,
            default: 'Cargando información'
        }
    }
};
</script>

<style scoped lang="scss">
.spinner {
    display: flex;
    align-items: center;
    margin: 20px 0;
}
</style>
